import { useEffect } from "react"
import { Redirect, RouteComponentProps } from "@reach/router"
import { FullPageLoader } from "@shared/primitive-components"
import { useAuth } from "../../../contexts"

export const Logout: React.FC<RouteComponentProps> = () => {
  const { isAuthenticated, isLoading, logout } = useAuth()

  useEffect(() => {
    ;(async () => {
      if (isAuthenticated) {
        await logout()
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])

  if (!isAuthenticated && !isLoading) {
    return <Redirect to="/login" />
  }

  return <FullPageLoader />
}
